import { createSlice } from "@reduxjs/toolkit";
import {initialUiState} from "../config/config.ui";

export const uiSlice = createSlice({
  name: "ui",
  initialState: initialUiState,
  reducers: {
    setShowFaq(state, action) {
      state.showFaq = action.payload;
    },
    setSelectedTab(state, action) {
      const tabId = action.payload;
      state.selectedTab = tabId;
    },
    setShowDataStepperModal(state, action) {
      state.showDataStepperModal = action.payload;
    }
  },
});
